<template>
  <div :class="mitraClass" class="badge-mitra ml-auto text-capitalize">{{type}}</div>
</template>

<script>
	export default {
		props: {
			type: {
				type: String,
				default: 'pending',
			},
		},
		computed: {
    mitraClass(){
      switch (this.type) {
        case 'registered':
        return 'bg-light-blue';
        case 'waiting':
        return 'bg-red';
        default:
        return 'bg-gray-2';
      }
      },
		},
	};
</script>

<style scoped>
</style>
